/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the CreativePreview HTTP resource (factory product). */
export class CreativePreviewResource {
}

export function createCreativePreviewResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const CreativePreview: any = createAdnHttpResource(send, 'creativepreview', () => localUserProfile);

  CreativePreview.getHtml = function(creativeId: any, context: any, ctx: any): Promise<any> {
    return send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['creativepreview', creativeId]),
      params: _.pickBy({context, ctx}, (value: any) => value !== undefined && value !== null && value !== ''),
      headers: {Accept: 'text/html'},
      responseType: 'text'
    });
  };

  return CreativePreview;
}

export const creativePreviewResourceProvider = {
  provide: CreativePreviewResource,
  useFactory: createCreativePreviewResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

